import { render, staticRenderFns } from "./GuidelinesDetailForm.vue?vue&type=template&id=56463c68&scoped=true"
import script from "./GuidelinesDetailForm.vue?vue&type=script&lang=js"
export * from "./GuidelinesDetailForm.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesDetailForm.vue?vue&type=style&index=0&id=56463c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56463c68",
  null
  
)

export default component.exports